/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import ModalConfirmacion from '../Comandos/ModalConfirmacion';
import ModalPersonalizado from '../Comandos/ModalPersonalizado';
import './InvData.css';
import { GiWindsock, GiBroom, GiHand } from 'react-icons/gi';
import { BsSnow3, BsArrowCounterclockwise } from 'react-icons/bs';
import { FaChartPie } from 'react-icons/fa';
import { MdOutlineMotionPhotosAuto } from 'react-icons/md';
import { TbLetterA } from 'react-icons/tb';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function InvData(props) {
    const { t } = useTranslation();
    const { childToParent, code, ct, inv } = props;
    var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
    const size_ico = 20;
    const variablesAPedir = "id,idCT,idInverter,status,color,activePower,reactivePower,nominalPower,peakPower,energyDay,productivity,cosPhi,temperature,vacR,vacS,vacT,iacR,iacS,iacT," +
        "inputPower,energyTotal,energyMonth,energyYear,pv1Voltage,pv1Current,pv2Voltage,pv2Current,pv3Voltage,pv3Current,pv4Voltage,pv4Current," +
        "pv5Voltage,pv5Current,pv6Voltage,pv6Current,pv7Voltage,pv7Current,pv8Voltage,pv8Current,pv9Voltage,pv9Current,pv10Voltage,pv10Current,pv11Voltage,pv11Current," +
        "pv12Voltage,pv12Current,peakPowerDay,timeStamp";
    const datosInmutables = (JSON.parse(sessionStorage.getItem("InverterConfiguration")));
    var [INV, setINV] = useState([]);
    var [htmlINV, setHtmlINV] = useState(<></>);
    const [comando, setComando] = useState("");
    const [abrirModal, setAbrirModal] = useState(false);
    const [abrirModalPers, setAbrirModalPers] = useState(false);
    const [abrirModalInv, setAbrirModalInv] = useState(false);
    const [device, setDevice] = useState();
    const [idInv, setIdInv] = useState('');


    // HABILITAR O DESHABILITAR COMANDOS
    let commandsClass = '';
    var commandsConfiguration = JSON.parse(window.sessionStorage.getItem("ScreenConfiguration"));
    commandsConfiguration = commandsConfiguration.filter(a => a.Screen === 'Commands')[0];
    if (!commandsConfiguration.Enabled) {
        commandsClass = 'inv-hide-commands';
    }

    // POPUPS
    const childToParentModal = (abrirModal) => {
        setAbrirModal(abrirModal)
    }
    const childToParentPers = (abrirModalPers) => {
        setAbrirModalPers(abrirModalPers)
    }
    const childToParentModalInv = (abrirModalInv) => {
        setAbrirModalInv(abrirModalInv)
    }

    // RECOGIDA DE DATOS
    let number = 0;

    useEffect(() => {
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/inverters?idSolarFarm=" + idParque + "&idCT=" + ct + "&idInverter=" + inv + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
            .then(async (dataINV) => { setINV(await dataINV.json()); })
            .catch(e => { console.log(e); })
        sessionStorage.setItem("ct", ct);
        sessionStorage.setItem("inv", inv);
        var interval1 = setInterval(function () {
            number++;
            if (code == sessionStorage.getItem("key") && ct == sessionStorage.getItem("ct") && inv == sessionStorage.getItem("inv")) { // No ha cambiado de página
                fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/inverters?idSolarFarm=" + idParque + "&idCT=" + ct + "&idInverter=" + inv + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
                    .then(async (dataINV) => { setINV(await dataINV.json()); })
                    .catch(e => { console.log(e); })
            } else { // Ha cambiado de página. Cancela bucle
                clearInterval(interval1);
            }
        }, 30000)
    }, [number, ct, inv, idParque, variablesAPedir, code]);


    //MAPEADO DE INVERSOR
    useEffect(() => {
        htmlINV = INV.map((datoINV, index) => {
            const { id, idCT, idInverter, timeStamp, status, color, activePower, reactivePower, nominalPower, peakPower, energyDay, productivity, cosPhi, temperature,
                vacR, vacS, vacT, iacR, iacS, iacT, inputPower, energyTotal, energyMonth, energyYear, pv1Voltage, pv1Current, pv2Voltage, pv2Current, pv3Voltage, pv3Current, pv4Voltage, pv4Current,
                pv5Voltage, pv5Current, pv6Voltage, pv6Current, pv7Voltage, pv7Current, pv8Voltage, pv8Current, pv9Voltage, pv9Current, pv10Voltage, pv10Current, pv11Voltage, pv11Current, pv12Voltage, pv12Current, peakPowerDay } = datoINV;
            if (idCT == ct && idInverter == inv) {
                const arrayPVvoltage = [pv1Voltage, pv2Voltage, pv3Voltage, pv4Voltage, pv5Voltage, pv6Voltage, pv7Voltage, pv8Voltage, pv9Voltage, pv10Voltage, pv11Voltage, pv12Voltage];
                const arrayPVcurrent = [pv1Current, pv2Current, pv3Current, pv4Current, pv5Current, pv6Current, pv7Current, pv8Current, pv9Current, pv10Current, pv11Current, pv12Current];
                var htmlStrings = <></>;
                var tabsStrings = <></>;
                var filaMPPT = <></>, filaStrings = <></>, filaVdc = <></>, filaIdc = <></>
                var filaMPPTMobil = <></>, filaStringsMobil = <></>, filaVdcMobil = <></>, filaIdcMobil = <></>
                var mpptNum, stringNum;
                datosInmutables.map((dato2) => {
                    if (id == dato2.id) {
                        mpptNum = dato2.mpptNumber;
                        childToParent(dato2.name);
                        stringNum = dato2.stringNumber;
                    }
                })

                for (var i = 1; i < (stringNum + 1); i++) {
                    if (i % 2 !== 0) {
                        filaMPPT = <>{filaMPPT}
                            <th colSpan={2}>MPPT {i / 2 + 0.5}</th>
                        </>
                    }
                    filaStrings = <>{filaStrings}
                        <td><h6>String{i}</h6></td>
                    </>
                    filaVdc = <>{filaVdc}
                        <td>Vdc: <strong>{arrayPVvoltage[i - 1]} V</strong></td>
                    </>
                    filaIdc = <>{filaIdc}
                        <td>Idc: <strong>{arrayPVcurrent[i - 1]} A</strong></td>
                    </>
                    if (i % 2 !== 0) {
                        filaMPPTMobil = <>{filaMPPTMobil}
                            <th colSpan={2}>MPPT {i / 2 + 0.5}</th>
                        </>
                    }
                    filaStringsMobil = <>{filaStringsMobil}
                        <td><h6>String{i}</h6></td>
                    </>
                    filaVdcMobil = <>{filaVdcMobil}
                        <td>Vdc: <strong>{arrayPVvoltage[i - 1]} V</strong></td>
                    </>
                    filaIdcMobil = <>{filaIdcMobil}
                        <td>Idc: <strong>{arrayPVcurrent[i - 1]} A</strong></td>
                    </>
                    if (i % 2 === 0) {
                        tabsStrings = <>{tabsStrings}
                            <table className='tabla-strings-inversores'>
                                <thead>
                                    <tr>{filaMPPTMobil}</tr>
                                </thead>
                                <tbody>
                                    <tr>{filaStringsMobil}</tr>
                                    <tr>{filaVdcMobil}</tr>
                                    <tr>{filaIdcMobil}</tr>
                                </tbody>
                            </table>
                        </>
                        filaMPPTMobil = null;
                        filaStringsMobil = null;
                        filaVdcMobil = null;
                        filaIdcMobil = null;
                    }

                }
                htmlStrings = <>{htmlStrings}
                    <thead>
                        <tr>{filaMPPT}</tr>
                    </thead>
                    <tbody>
                        <tr>{filaStrings}</tr>
                        <tr>{filaVdc}</tr>
                        <tr>{filaIdc}</tr>
                    </tbody>
                </>
                console.log(htmlStrings);

                var color_
                if (color === "#ffffff") { color_ = ("#000000") } else { color_ = color }
                return (
                    <div key={index}>
                        <div className='row'>
                            <div className='col' style={{ marginTop: "5px" }}>
                                {t('scada.solarFarm.inverter.readDate')} <strong>{timeStamp}</strong>
                            </div>
                        </div>
                        <div className='row' id='row-2-inv-screen'>
                            <div className='col col-auto'>
                                <div className='row' style={{ marginTop: '5px' }}>
                                    <div className='col-4 importantes' style={{ marginTop: '5px' }}>
                                        <div className='margin-left-importantes'>{t('scada.solarFarm.inverter.status')}&nbsp;<strong style={{ color: color_ }}>{status}</strong></div>
                                        <div className='margin-left-importantes'>{t('scada.solarFarm.inverter.energy')}&nbsp;<strong>{energyDay}&nbsp;kWh</strong></div>
                                        <div className='margin-left-importantes'>{t('scada.solarFarm.inverter.active')}&nbsp;<strong>{activePower}</strong></div>
                                    </div>
                                    <div className='col col-auto' style={{ marginTop: '5px' }}>
                                        <div>{t('scada.solarFarm.inverter.productivity')}&nbsp;<strong>{productivity}</strong></div>
                                        <div>{t('scada.solarFarm.inverter.nominal')}&nbsp;<strong>{nominalPower}</strong></div>
                                        <div>{t('scada.solarFarm.inverter.energy2')}&nbsp;<strong>{energyMonth}</strong></div>
                                    </div>
                                    <div className='col col-auto' style={{ marginTop: '5px' }}>
                                        <div>{t('scada.solarFarm.inverter.peak')}&nbsp;<strong>{peakPower}</strong></div>
                                        <div>{t('scada.solarFarm.inverter.reactive')}&nbsp;<strong>{reactivePower}</strong></div>
                                        <div>{t('scada.solarFarm.inverter.energy3')}&nbsp;<strong>{energyYear}</strong></div>
                                    </div>
                                </div>
                                <div className='row' style={{ marginTop: '5px' }}>
                                    <div className='col col-auto' style={{ marginTop: '5px' }}>
                                        <div>{t('scada.solarFarm.inverter.peakToday')}&nbsp;<strong>{peakPowerDay}&nbsp;</strong></div>
                                        <div>{t('scada.solarFarm.inverter.powerFactor')}&nbsp;<strong>{cosPhi}</strong></div>
                                        <div>{t('scada.solarFarm.inverter.totalEnergy')}&nbsp;<strong>{energyTotal}&nbsp;</strong></div>
                                    </div>
                                    <div className='col col-auto temperatura-inv' style={{ marginTop: '5px' }}>
                                        <div>{t('scada.solarFarm.inverter.temperature')}&nbsp;<strong>{temperature}&nbsp;</strong></div>
                                    </div>
                                </div>
                                <div className='row' style={{ marginTop: '30px' }}>
                                    <div className='col-12 col-lg-auto mb-3'>
                                        <h5 className={commandsClass} id='h5-commands'>{t('scada.solarFarm.inverter.commands')}</h5>
                                        <a className={commandsClass} id='a-inv-command-start' onClick={() => { setDevice(2); setAbrirModalInv(true); setComando('ON'); setIdInv(id) }}>START</a>
                                        <a className={commandsClass} id='a-inv-command-stop' onClick={() => { setDevice(2); setAbrirModalInv(true); setComando('OFF'); setIdInv(id) }}>STOP</a>
                                    </div>

                                    <div className='col' id='col-1-inv-screen'>
                                        <div className='row'>
                                            <div className='col col-auto'>
                                                <h6>DC</h6>
                                                <ul id='ul-dc'>
                                                    <li>{t('scada.solarFarm.inverter.enterPower')} <strong>{inputPower}</strong></li>
                                                </ul>
                                            </div>
                                            <div className='col col-auto'>
                                                <h6>AC</h6>
                                                <ul id='ul-ac-voltage'>
                                                    <li>Vac&nbsp;R:&nbsp;<strong>{vacR}</strong></li>
                                                    <li>Vac&nbsp;S:&nbsp;<strong>{vacS}</strong></li>
                                                    <li>Vac&nbsp;T:&nbsp;<strong>{vacT}</strong></li>
                                                </ul>
                                                <ul id='ul-ac-current'>
                                                    <li>Iac&nbsp;R:&nbsp;<strong>{iacR}</strong></li>
                                                    <li>Iac&nbsp;S:&nbsp;<strong>{iacS}</strong></li>
                                                    <li>Iac&nbsp;T:&nbsp;<strong>{iacT}</strong></li>
                                                </ul>
                                            </div>
                                            <div className='col mb-3' />
                                            <div className='col mb-3' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col' style={{ marginTop: '5px' }}>
                                <div><iframe src={"https://eurus.energynebula.com/grafana/d-solo/4bq30_iNk/scada-solar-inverter-data?orgId=1&refresh=1m&theme=light&from=now-720m&to=now&panelId=2&var-ct=" + idCT + "&var-IdInverter="+idInverter} width="100%" height="300" frameborder="0"></iframe></div>
                            </div>
                        </div>
                        <div className='row' style={{ marginTop: '10px' }}>
                            <div className='col'>
                                <h6>Nº&nbsp;MPPT:&nbsp;{mpptNum}</h6>
                            </div>
                        </div>
                        <div className='row tabla-inversores-pc'>
                            <table className='tabla-strings-inversores'>
                                {htmlStrings}
                            </table>
                        </div>
                        <div className='row tabla-inversores-movil'>
                            {tabsStrings}
                        </div>

                    </div>
                );
            }
        });
        setHtmlINV(htmlINV);
    }, [INV]);

    // ---------------------------------------------------------------------- TRACKER DATA -------------------------------------------------------------------------------------------------
    const variablesAPedirTracker = "id,idDevice,idCT,idInverter,idTracker,name,actualPosition,status,color,targetPosition,notAtSetpoint,stop,motorBlocked,overcurrent,notUsed,communicationStatus,manualMode,timeStamp,colorTimeStamp";

    //Comandos
    var comandos = (JSON.parse(sessionStorage.getItem("commands")));
    const [displayTCU, setDisplayTCU] = useState('none');//Si hay por TCU individual
    const [displayTCUWind, setDisplayTCUWind] = useState('none');
    const [displayTCUSnow, setDisplayTCUSnow] = useState('none');
    const [displayTCUClean, setDisplayTCUClean] = useState('none');
    const [displayTCUPerso, setDisplayTCUPerso] = useState('none');
    const [displayTCUReset, setDisplayTCUReset] = useState('none');
    const [displayTCUResetAlarm, setDisplayTCUResetAlarm] = useState('none');
    const [displayTCUAuto, setDisplayTCUAuto] = useState('none');
    const [displayTCUManual, setDisplayTCUManual] = useState('none');


    //*****/
    var [TCU, setTCU] = useState([]);
    var [htmlTCU, setHtmlTCU] = useState(<></>);
    var [enviarLista, setEnviarLista] = useState('');

    var listaTrackers = [];
    var [listaTrackersAux, setListaTrackersAux] = useState([]);

    //Si cambiamos de inversor, ct o parque, todo los trackers marcados se eliminan
    useEffect(() => {
        limpiarLista(true);
    }, [ct, inv, idParque]);

    //Función de limpieza de checkbox y lista de trackers seleccionados
    //al mandar un comando o cambiar de dispositivo
    const limpiarLista = (limpiarCheckbox) => {
        for (let i = 0; i < TCU.length; i++) {
            if (limpiarCheckbox === true) {
                document.getElementById(TCU[i].idTracker).checked = false;
                actualizarStringTracker(-1);
            }
        }
    }

    //Se transforma la lista de los trackers antes de pasarsela a la api
    function tranformarLista(listaTrackers) {
        var lista = "";
        for (let i = 0; i < listaTrackers.length; i++) {
            if (i + 1 !== listaTrackers.length) {
                lista += listaTrackers[i] + ","
            } else {
                lista += listaTrackers[i]
            }
        }
        setEnviarLista(lista);
    }

    //Recogida datos de tracker
    let number2 = 0;
    useEffect(() => {
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/trackers?idSolarFarm=" + idParque + "&idCT=" + ct + "&idInverter=" + inv + "&variables=" + variablesAPedirTracker, { method: 'GET', credentials: 'include' })
            .then(async (dataTCU) => { setTCU(await dataTCU.json()); })
            .catch(e => { console.log(e); })
        var interval1 = setInterval(function () {
            number++;
            if (code == sessionStorage.getItem("key") && ct == sessionStorage.getItem("ct") && inv == sessionStorage.getItem("inv")) { // No ha cambiado de página
                fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/trackers?idSolarFarm=" + idParque + "&idCT=" + ct + "&idInverter=" + inv + "&variables=" + variablesAPedirTracker, { method: 'GET', credentials: 'include' })
                    .then(async (dataTCU) => { setTCU(await dataTCU.json()); })
                    .catch(e => { console.log(e); })
            } else { // Ha cambiado de página. Cancela bucle
                clearInterval(interval1);
            }
        }, 30000)
    }, [number2, ct, inv, idParque, code]);

    //Activar o desactivar botones comandos
    var [descactivarBotCom, setDescactivarBotCom] = useState("disabled");

    // Actualizar string de la consulta a la API según qué Trackers están marcados
    const actualizarStringTracker = (id) => {

        if (id === -1) {//Cuando se ha mandado un comando, limpiamos todas las listas
            listaTrackers.splice(0, listaTrackers.length);
            setEnviarLista('');
            setListaTrackersAux(listaTrackersAux.splice(0, listaTrackersAux.length));
        } else if (listaTrackers.includes(id)) {
            listaTrackers.splice(listaTrackers.indexOf(id), 1)
        } else {
            listaTrackers.push(id)
        }

        //Si hay trackers seleccionados habilitamos los botones de comandos.
        if (listaTrackers != null && listaTrackers != undefined && listaTrackers != "" && listaTrackers.length != 0) {
            setDescactivarBotCom("");
        } else {
            setDescactivarBotCom("disabled");
        }

        setListaTrackersAux(listaTrackers);
    }

    useEffect(() => {
        var htmlTemp = <></>
        setHtmlTCU(<></>)
        for (let i = 0; i < TCU.length; i++) {
            var _color = TCU[i].color;
            if (_color === "#ffffff") { _color = "#000000" };
            if (TCU[i].idCT == ct && TCU[i].idInverter == inv) {
                htmlTemp = <>{htmlTemp}
                    <tr className='tcu-inv-screen-tbody-tr' key={i}>
                        <td className={'tcu-inv-screen-td ' + commandsClass}><input className="form-check-input" type="checkbox" value="" id={TCU[i].idTracker} onClick={() => { actualizarStringTracker(TCU[i].id) }} /></td>
                        <td className='tcu-inv-screen-td' style={{ width: "fit-content", fontSize: "15px" }}><strong>{TCU[i].name}</strong></td>
                        <td className="text-center tcu-inv-screen-td">{TCU[i].actualPosition}º</td>
                        <td className="text-center tcu-inv-screen-td">{TCU[i].targetPosition}º</td>
                        <td className="text-center tcu-inv-screen-td" style={{ color: _color }}><strong>{TCU[i].status}</strong></td>
                        <td className='tcu-inv-screen-td'><div className={TCU[i].notAtSetpoint == false && TCU[i].communicationStatus == false && TCU[i].colorTimeStamp !== "red" ? 'tcu-led-inactive' : 'tcu-led-active'} /></td>
                        <td className='tcu-inv-screen-td'><div className={TCU[i].stop == false && TCU[i].communicationStatus == false && TCU[i].colorTimeStamp !== "red" ? 'tcu-led-inactive' : 'tcu-led-active'} /></td>
                        <td className='tcu-inv-screen-td'><div className={TCU[i].motorBlocked == false && TCU[i].communicationStatus == false && TCU[i].colorTimeStamp !== "red" ? 'tcu-led-inactive' : 'tcu-led-active'} /></td>
                        <td className='tcu-inv-screen-td'><div className={TCU[i].overcurrent == false && TCU[i].communicationStatus == false && TCU[i].colorTimeStamp !== "red" ? 'tcu-led-inactive' : 'tcu-led-active'} /></td>
                        <td className='tcu-inv-screen-td'><div className={TCU[i].notUsed == false && TCU[i].communicationStatus == false && TCU[i].colorTimeStamp !== "red" ? 'tcu-led-inactive' : 'tcu-led-active'} /></td>
                        <td className='tcu-inv-screen-td'><div className={TCU[i].communicationStatus == false && TCU[i].colorTimeStamp !== "red" ? 'tcu-led-inactive' : 'tcu-led-active'} /></td>
                        <td className='tcu-inv-screen-td'><div className={TCU[i].manualMode == false && (TCU[i].communicationStatus == false && TCU[i].colorTimeStamp !== "red") ? 'tcu-led-inactive' : 'tcu-led-active'} /></td>
                        <td className='text-center ncu-hover-pointer tcu-inv-screen-td' style={{ color: TCU[i].colorTimeStamp }}>{TCU[i].timeStamp}</td>
                    </tr>
                </>
            }
        }
        setHtmlTCU(htmlTemp)
    }, [TCU]);


    useEffect(() => {
        for (let i = 0; i < comandos.length; i++) {

            switch (comandos[i].IdDevice) {
                case 3://Tracker
                    if (displayTCU === 'none') {//Para que no haga por cada comando 
                        setDisplayTCU(''); //un set de este display
                    }
                    switch (comandos[i].Command) {
                        case 'WIND':
                            if (displayTCUWind === 'none') {
                                setDisplayTCUWind('');
                            }
                            break;
                        case 'SNOW':
                            if (displayTCUSnow === 'none') {
                                setDisplayTCUSnow('');
                            }
                            break;
                        case 'CLEAN':
                            if (displayTCUClean === 'none') {
                                setDisplayTCUClean('');
                            }
                            break;
                        case 'PERSO':
                            if (displayTCUPerso === 'none') {
                                setDisplayTCUPerso('');
                            }
                            break;
                        case 'RESET':
                            if (displayTCUReset === 'none') {
                                setDisplayTCUReset('');
                            }
                            break;
                        case 'RESET_ALARM':
                            if (displayTCUResetAlarm === 'none') {
                                setDisplayTCUResetAlarm('');
                            }
                            break;
                        case 'AUTO':
                            if (displayTCUAuto === 'none') {
                                setDisplayTCUAuto('');
                            }
                            break;
                        case 'MANUAL':
                            if (displayTCUManual === 'none') {
                                setDisplayTCUManual('');
                            }
                            break;
                        default:
                    }
                    break;
                default:

            }
        }
    }, []);


    if (TCU.length > 0) {
        var htmlTable = <>
            <div className='row' style={{ borderTop: "solid 1px black", displau: displayTCU }}>
                <div className='col-auto' style={{ marginTop: "2%", display: displayTCUWind }}>
                    <button className='btn btn-primary tcu-command' disabled={descactivarBotCom} onClick={() => { setDevice(3); setAbrirModal(true); setComando('WIND'); tranformarLista(listaTrackersAux); }}><GiWindsock size={size_ico} title={t('scada.map.popupTCU.commands.wind')} /></button>
                </div>
                <div className='col-auto' style={{ marginTop: "2%", display: displayTCUSnow }}>
                    <button className='btn btn-primary tcu-command' disabled={descactivarBotCom} onClick={() => { setDevice(3); setAbrirModal(true); setComando('SNOW'); tranformarLista(listaTrackersAux) }}><BsSnow3 size={size_ico} title={t('scada.map.popupTCU.commands.snow')} /></button>
                </div>
                <div className='col-auto' style={{ marginTop: "2%", display: displayTCUClean }}>
                    <button className='btn btn-primary tcu-command' disabled={descactivarBotCom} onClick={() => { setDevice(3); setAbrirModal(true); setComando('CLEAN'); tranformarLista(listaTrackersAux) }}><GiBroom size={size_ico} title={t('scada.map.popupTCU.commands.clean')} /></button>
                </div>
                <div className='col-auto' style={{ marginTop: "2%", display: displayTCUPerso }}>
                    <button className='btn btn-primary tcu-command' disabled={descactivarBotCom} onClick={() => { setDevice(3); setAbrirModalPers(true); setComando('PERSO'); tranformarLista(listaTrackersAux) }}> <FaChartPie size={size_ico} title={t('scada.map.popupTCU.commands.perso')} /></button>
                </div>
                <div className='col-auto' style={{ marginTop: "2%", display: displayTCUReset }}>
                    <button className='btn btn-primary tcu-command' disabled={descactivarBotCom} onClick={() => { setDevice(3); setAbrirModal(true); setComando('RESET'); tranformarLista(listaTrackersAux) }}><BsArrowCounterclockwise size={size_ico} title={t('scada.map.popupTCU.commands.reset')} /></button>
                </div>
                <div className='col-auto' style={{ marginTop: "2%", display: displayTCUAuto }}>
                    <button className='btn btn-primary tcu-command' disabled={descactivarBotCom} onClick={() => { setDevice(3); setAbrirModal(true); setComando('AUTO'); tranformarLista(listaTrackersAux) }}><TbLetterA size={size_ico} title={t('scada.map.popupTCU.commands.auto')} /></button>
                </div>
                <div className='col-auto' style={{ marginTop: "2%", display: displayTCUManual }}>
                    <button className='btn btn-primary tcu-command' disabled={descactivarBotCom} onClick={() => { setDevice(3); setAbrirModal(true); setComando('MANUAL'); tranformarLista(listaTrackersAux) }}><GiHand size={size_ico} title={t('scada.map.popupTCU.commands.manual')} /></button>
                </div>
                <div className='col-auto' style={{ marginTop: "2%", display: displayTCUResetAlarm }}>
                    <button className='btn btn-primary tcu-command' disabled={descactivarBotCom} onClick={() => { setDevice(3); setAbrirModal(true); setComando('RESET_ALARM'); tranformarLista(listaTrackersAux) }}><MdOutlineMotionPhotosAuto size={size_ico} title={t('scada.map.popupTCU.commands.reset_alarms')} /></button>
                </div>
            </div>
            <div className='row'>
                <div className='col' style={{ marginTop: "0.5%", padding: "0" }}>
                    <Table striped bordered hover className='tcu-inv-screen-table'>
                        <thead className='tcu-inv-screen-thead'>
                            <tr className='tcu-inv-screen-head-tr'>
                                <th className={commandsClass}>{t('scada.solarFarm.inverter.table.command')}</th>
                                <th>TCU</th>
                                <th>{t('scada.solarFarm.inverter.table.currentPos')}</th>
                                <th>{t('scada.solarFarm.inverter.table.targetPos')}</th>
                                <th>{t('scada.solarFarm.alarm.table.state')}</th>
                                <th>{t('scada.solarFarm.ncu.sp')}</th>
                                <th>&nbsp;&nbsp;Stop&nbsp;</th>
                                <th>{t('scada.solarFarm.ncu.motor')}</th>
                                <th>{t('scada.solarFarm.ncu.overcurrent')}</th>
                                <th>{t('scada.solarFarm.ncu.low')}</th>
                                <th>Com</th>
                                <th>Auto.</th>
                                <th>{t('scada.solarFarm.ncu.readDate')}</th>
                            </tr>
                        </thead>
                        <tbody className='tcu-inv-screen-tbody'>
                            {htmlTCU}
                        </tbody>
                    </Table>
                </div>
            </div>
        </>
    }
    return (
        <div className='container-fluid' style={{ marginTop: '15px' }}>
            {htmlINV}
            {htmlTable}
            <Modal centered show={abrirModalInv} onHide={() => setAbrirModalInv(false)} backdrop="static" aria-labelledby="reset_modal" >
                <Modal.Header closeButton>
                    <Modal.Title>{comando}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalConfirmacion comando={comando} dispositivo={device} cerrarModal={childToParentModalInv} ids={idInv} />
                </Modal.Body>
            </Modal>
            <Modal centered show={abrirModal} onHide={() => setAbrirModal(false)} backdrop="static" aria-labelledby="reset_modal" >
                <Modal.Header closeButton>
                    <Modal.Title>{comando}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalConfirmacion comando={comando} dispositivo={device} cerrarModal={childToParentModal} ids={enviarLista} limpiarCheckbox={limpiarLista} />
                </Modal.Body>
            </Modal>
            <Modal centered show={abrirModalPers} onHide={() => setAbrirModalPers(false)} backdrop="static" aria-labelledby="reset_modal">
                <Modal.Header closeButton>
                    <Modal.Title>{t('scada.map.popupTCU.manualDegrees')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalPersonalizado comando={comando} dispositivo={device} cerrarModal={childToParentPers} ids={enviarLista} limpiarCheckbox={limpiarLista} />
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default InvData;